<!-- 中观逻辑详解 -->
<template>
  <div style="width: 100%;" v-if="ZGTodayData.fundingSupply">
    <H3Title :title="'逻辑详解'"></H3Title>

    <div class="seesaw-wrap">
      <div class="seesaw-left"
        :class="{'seesaw-left': true, 'lighter': larger==='rightHeavy'}">
        <div class="seesaw-parent">
          <div class="relative">
            <div class="ball blue" style="top: 13px;left: 79px;">QFII RQFII</div>
            <div class="ball blue" style="top: 56px;padding: 2px;">打板资金</div>
            <div class="ball blue" style="top: 19px;left: 16px;">陆股通</div>
            <div class="ball blue" style="top: 45px;left: 103px;">公募资金</div>
            <div class="ball blue" style="top: 84px;left: 94px;">增持资金</div>
            <div class="ball blue" style="top: 103px;left: 59px;">回购资金</div>
            <div class="ball blue big" style="top: 45px;left: 42px;padding: 13px;">杠杆资金</div>
            <div class="ball blue" style="top: 92px;left: 19px; padding-top: 9px;">其他</div>
          </div>
        </div>
      </div>
      <div 
        :class="{'seesaw-right': true, 'lighter': larger==='leftHeavy'}">
        <div class="seesaw-parent">
          <div class="relative">
            <div class="ball red middle" style="top: 55px; left: 44px;">定增金额</div>

            <div class="ball red middle" style="top: 34px;left: 90px;width: 53px;height: 53px;">配股金额</div>

            <div class="ball red" style="top: 86px; left: 94px;">减持金额</div>

            <div class="ball red " style="top: 92px; left: 18px;padding-top:10px;">IPO</div>

            <div class="ball red" style="top: 104px; left: 57px;padding-top:10px;">其他</div>

            <div class="ball red" style="top: 56px;left: 0px;padding-top:10px;">其他</div>

            <div class="ball red" style="top: 12px;left: 17px;width: 51px;height: 51px; padding-top: 14px;">其他</div>
          </div>
        </div>
      </div>
    </div>

    <div class="conclusion-wrap">
      <div :class="{'arrow-box':true, 'larger': larger==='leftHeavy'}">arrow</div>
      <div style="width: 142px; display: inline-block; ">
        <div class="center-arrow">kk</div>
        <p class="conclusion">资金供给 {{sign}} 资金需求</p>
      </div>
    </div>
  </div>
</template>

<script>
import H3Title from "@/components/H3Title";

export default {
  name: "ZGLogicDetail",
  components: {
    H3Title
  },
  props: {
    ZGTodayData: {
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  computed:{
    sign(){
      return this.larger === 'leftHeavy' ? '>':'<';
    },
    larger(){
      return this.ZGTodayData.fundingSupply.value >= this.ZGTodayData.currencyLiquidity.value ? 'leftHeavy':'rightHeavy'
    }
  },
  data() {
    return {
      chart: {}
    };
  },
  mounted() {}
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
.seesaw-wrap{
  display:flex;
  margin-top: 40px;
}
.seesaw-left{
  flex: 1;
  text-align: center;
}
.seesaw-right{
  flex: 1;
  text-align: center;
}
.seesaw-parent{
  background: #25262A;
  width: 147px;
  height: 147px;
  display: inline-block;
  border: 1px solid #434448;
  border-radius: 50%;
}
.relative{
  position: relative;
}
.ball{
  position: absolute;
  top: 0px;
  width: 41px;
  height: 41px;
  border-radius: 50%;
  font-size: 12px;
  color: #d2d2d3;
  padding: 2px;
}
.red{
  border: 1px solid rgba(253,67,50,1);
  background: rgba(253,67,50,0.2);
}
.blue{
  background: rgba(0,150,255,0.2);
  border:1px solid rgba(0,150,255,1);
}
.grey{
  border:1px solid rgba(67,68,72,1);
  background: rgba(67,68,72,0.2);
}
.middle{
  width: 50px;
  height: 50px;
  padding: 8px;
}
.big{
  width: 59px;
  height: 59px;
}
.conclusion-wrap{
  text-align: center;
  margin-top: -28px;
}
.conclusion{
  font-size: 12px;
  border: 1px solid #434448;
  display: block;
  padding: 2px 10px;
  line-height: 22px;
  color: #fff;
  margin-top: -7px;
  font-family: sans-serif;
}
.arrow-box{
  width: 78%;
  display: inline-block;
  border-bottom: 2px solid #434448;
  text-indent: -999em;
  transform: rotate(2deg);
}
.center-arrow{
  background: url('//s.thsi.cn/js/zijinquanxi/assets/images/seearrow.png');
  width: 18px;
  height: 10px;
  display: inline-block;
  overflow: hidden;
  text-indent: -999em;
}
.larger{
  transform: rotate(-2deg);
}
.lighter{
  margin-top: -8px;
}
</style>
